import '../styles/_global.scss';
import lazySizes from "lazysizes";
import './tools/lazybg';
import './tools/header'

const faqs = Array.from(document.getElementsByClassName("faqs__accordion-item"));



if(faqs?.length > 0) {
    for(let i = 0; i < faqs.length; i++) {
        faqs[i].addEventListener('click', openFaq, false);
    }
}

function openFaq() {
    if(this.classList.contains('open')) {
        faqs.forEach(div => {
            div.classList?.remove('open')
        });
    } else {
        faqs.forEach(div => {
            div.classList?.remove('open')
        });
        this.classList?.add('open')
    }
}
const btns = document.querySelectorAll(".ball");
const popups = document.querySelectorAll(".popup");
if(btns?.length > 0) {
    btns.forEach(btn => {
        btn.addEventListener('click', () => {
            popups.forEach(popup => {
                if(!popup.classList.contains("d-none")) {
                    popup.classList.add("d-none");
                }
            });
            btn.parentNode.querySelector(".popup").classList.toggle("d-none");
        })
    })
}





